import { createContext } from "react";

const BirthFormContext = createContext();

export default BirthFormContext;
